export default {"src":"/_next/static/media/logoPrincipal.0d16b90b.svg","height":133,"width":217};